import { render, staticRenderFns } from "./Cutoff.vue?vue&type=template&id=f31235a8"
import script from "./Cutoff.vue?vue&type=script&lang=js"
export * from "./Cutoff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports